export default {
  kandyApiKey: 'DAK5cff97fc225d417ebd13bb12e46a0cd8',
  kandyLoginTimer: 60000,
  locale: 'zh-cn',
  chromeExtensionId: 'geanejeadifogbjjpjeceibbljgjfimh',
  screenCaptureExtensionId: 'pmpndpdjojcobafjeagljbpkpllecjld',
  companyId: 'fastclaim',
  uersTimeOut: 30,
  domain: "gdrbydstest.fastclaim.com.cn",
  rate: ["非常满意", "满意", "一般", "不满意", "非常不满意"],
  callStatus: ['排队中', '开始会话', '取消会话', '结束会话'],
  appType: "lossAss",
  lossAssLink: "https://dev.fastclaimpro.com/AssessorMain",
  maxAgents: 50,
  companyName: '上海太平',
  LossLink: 'https://boards-dzh-test.fastclaimpro.com/loss',
  searchTenant: '5e3cbb6939e4d500074a3b5e',
  medicalcheckDomain: 'https://medicalcheck-test.fastclaimpro.com',
  domainForIframe: 'https://test-support.fastclaimpro.com',
  newMedicalcheckDomain: 'https://medical_new-test.fastclaimpro.com/#',
  server: 'tpatest',
  wxWorkDomain: 'https://tpa-wxwork-test.fastclaimpro.com'
}
